<div class="modal-header">
    <h4 class="modal-title">Quote Line</h4>
</div>
<div class="modal-body">
    @if (quoteLine) {
    <dx-form [formData]="quoteLine" validationGroup="quoteLineValidationGroup">
        @if (!quoteLine.isMisc) {
        <dxi-item
            dataField="productId"
            editorType="dxSelectBox"
            [editorOptions]="{ dataSource: productsDS, displayExpr: 'partNumber', valueExpr: 'id', onValueChanged: productChanged }"
            [label]="{ text: 'Product' }"
            [isRequired]="true"
        ></dxi-item>
        }
        <dxi-item dataField="partNumber" [editorOptions]="{ disabled: !quoteLine.isMisc }"> </dxi-item>
        <dxi-item dataField="unit" [editorOptions]="{ disabled: true }"> </dxi-item>
        <dxi-item dataField="price" editorType="dxNumberBox" [editorOptions]="{ format: { type: 'currency', precision: 2 }, step: 0 }" [isRequired]="true"> </dxi-item>
        <dxi-item dataField="quantity" editorType="dxNumberBox" [editorOptions]="{ step: 0 }" [isRequired]="true"></dxi-item>
        <dxi-item dataField="description" editorType="dxTextArea" [editorOptions]="{ height: '125px' }"> </dxi-item>
        <dxi-item dataField="notes" editorType="dxTextArea" [editorOptions]="{ height: '125px' }"> </dxi-item>
    </dx-form>
    }
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-success" (click)="save()">Save</button>
    <button type="button" class="btn btn-light" (click)="cancel()">Cancel</button>
</div>
